function options(data) {
    if (data.options) {
        let markup = ''
        for (let i = 0; i < data.options.length; i++) {
            // prettier-ignore
            markup += `<div class="radio-tabs__radio">
                <input type="radio" data-element="input" class="radio-tabs__input" id="${data.options[i].name}"
                value="${data.options[i].name}"
                name="filters[${data.handle}]" ${data.options[i].selected ? 'selected' : ''}>
                <label for="${data.options[i].name}" class="radio-tabs__label ${data.options[i].selected ? 'radio-tabs__label--active' : ''}">${data.options[i].name}</label>
            </div>`
        }
        return markup
    } else {
        return ''
    }
}

const template = (data) => `
    <div class="radio-tabs">
        ${options(data)}
    </div`
export default template
